module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60eb6f3ec10cb788f4e7213b3c012de3.png";